import { Container } from 'react-bootstrap';
import GpuOneTabs from '../components/GlobalGpuOneTabs';

const GlobalGpuOnePage = () => {
	return (
		<Container>
			<h3 className="page-title">GPU One </h3>
			<br />
			<GpuOneTabs />
		</Container>
	);
};

export default GlobalGpuOnePage;
